<template>
	<v-btn depressed text :color="color" @click="trataAcaoDeBotaoDesabilitado(() => $emit('click'))">
		<span v-if="icone" class="material-icons mr-1">{{ icone }}</span>
		<span v-if="texto">{{ texto }}</span>
	</v-btn>
</template>

<script>
import trataAcaoDeBotaoDesabilitado from '@/views/mixins/trataAcaoDeBotaoDesabilitado'

export default {
	name: 'botao-texto',
	mixins: [trataAcaoDeBotaoDesabilitado],
	props: {
		icone: {
			type: String,
			default: '',
		},
		texto: {
			type: String,
			default: '',
		},
		color: {
			type: String,
			default: 'secondary',
		},
	},
}
</script>

<style scoped lang="stylus"></style>
